import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './sa_reboot.routes';

import SaConfigService from '../../../components/api/sa_config/sa_config.service';
import ControllerConfigService from '../../../components/api/controller_config/controller_config.service';

export class SaRebootController {
  /*@ngInject*/
  constructor($q, SaConfigService, ControllerConfigService) {
    this.$q = $q;
    this.SaConfigService = SaConfigService;
    this.ControllerConfigService = ControllerConfigService;

    this.devices = [];
  }

  $onInit() {
    this.$q.all([
      this.SaConfigService.api.index().$promise,
      this.ControllerConfigService.api.index().$promise
    ]).then(responses => {
      this.devices = responses[0].concat(responses[1]);
    });
  }
}

export default angular.module('leptonApp.saReboot', [uiRouter, SaConfigService, ControllerConfigService])
  .config(routing)
  .component('saReboot', {
    template: require('./sa_reboot.html'),
    controller: SaRebootController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/sa_reboot/end_user/sa_reboot.component.js